module.exports = __webpack_public_path__ + "img/modal-bg.ae9d4eb2.svg";